import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatPercentOneDecimal } from '@bingads-webui-campaign/recommendation-core';
import { TooltipHost, DirectionalHint, TooltipDelay } from '@fluentui/react';
import {
  Badge,
} from '@fluentui/react-components';

export class RecommendationOptimizationScoreTag extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string.isRequired,
    optimizationScore: PropTypes.number,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
  };

  static defaultProps = {
    optimizationScore: 0,
    newI18n: {
      getString: _.noop,
    },
  };

  render() {
    const {
      className, optimizationScore, i18n, newI18n,
    } = this.props;

    let optimizationScoreTagContent;
    let calloutContent;
    if (_.isNull(optimizationScore)) {
      optimizationScoreTagContent = (<div className="not-available-line" >-</div>);
      calloutContent = newI18n.getString(_TL_('Not currently scored'));
    } else if (optimizationScore === 0) {
      optimizationScoreTagContent = (<div className={classNames('iconba', 'iconba-Trending12', 'zero-score')} />);
      calloutContent = newI18n.getString(_TL_('The score uplift is very low. While it\'s still recommended to apply it to help your account performance well. Have a try!'));
    } else {
      const formatedScore = `+${formatPercentOneDecimal(optimizationScore, i18n)}`;
      optimizationScoreTagContent = (<div className="optimization-score-tag-content">{formatedScore}</div>);
      calloutContent = i18n.getString('Summary_Card_Optimization_Score_Tag_Normal_Callout', { optimization_score: formatedScore.slice(1) });
    }

    const hostStyles = {
      root: {
        display: 'inline-block',
      },
    };
    const calloutProps = { gapSpace: 7 };
    const tooltipProps = {
      maxWidth: '231px',
      styles: {
        root: {
          padding: '8px 10px',
        },
      },
      delay: TooltipDelay.long,
    };

    return (
      <div className="summary-card-os-tag-container">
        <TooltipHost
          content={calloutContent}
          directionalHint={DirectionalHint.bottomCenter}
          styles={hostStyles}
          calloutProps={calloutProps}
          tooltipProps={tooltipProps}
        >
          <div className={className}>
            <Badge
              appearance="outline"
            >
              {optimizationScoreTagContent}
            </Badge>
          </div>
        </TooltipHost>
      </div>
    );
  }
}
